import { Text, type TextProps, StyleSheet } from "react-native";

import { useThemeColor } from "@/hooks/useThemeColor";
import { fonts } from "@/constants/fonts";

export type ThemedTextProps = TextProps & {
  lightColor?: string;
  darkColor?: string;
  type?: "default" | "title" | "defaultSemiBold" | "subtitle" | "link";
};

export default function ThemedText({
  style,
  lightColor,
  darkColor,
  type = "default",
  ...rest
}: ThemedTextProps) {
  const color = useThemeColor({ light: lightColor, dark: darkColor }, "text");

  return (
    <Text
      style={[
        { color },
        type === "default" ? styles.default : undefined,
        type === "title" ? styles.title : undefined,
        type === "defaultSemiBold" ? styles.defaultSemiBold : undefined,
        type === "subtitle" ? styles.subtitle : undefined,
        type === "link" ? styles.link : undefined,
        style,
      ]}
      {...rest}
    />
  );
}

const styles = StyleSheet.create({
  default: {
    fontSize: 16,
    fontFamily: fonts.regular,
  },
  defaultSemiBold: {
    fontSize: 16,
    fontFamily: fonts.semiBold,
  },
  title: {
    fontSize: 32,
    fontFamily: fonts.bold,
  },
  subtitle: {
    fontSize: 20,
    fontFamily: fonts.bold,
  },
  link: {
    fontSize: 16,
    fontFamily: fonts.medium,
    color: "#0a7ea4",
  },
});
